import * as Highcharts from 'highcharts';
import 'highcharts/highcharts-more';
import 'highcharts/modules/boost';
import '../../highcharts-options';

import * as utils from '../../../utils'
import { Aeroval } from '../../../types/global';
import './style.css'
declare var aeroval: Aeroval;


type StripesData = {
    [year: number]: {
        [season in 'DJF' | 'MAM' | 'JJA' | 'SON']: {
            [statistics: string]: number | null
        }
    }
}

export function plotStripes(stripesData: StripesData, div: string, _chartOptions: any = {}) {
    const targets = {
        rms: {
            forecast: {
                conco3: 18,
                conco3mda8: 18,
                concno2: 25,
                concpm10: 18,
                concpm25: 18
            },
            analysis: {
                conco3: 16,
                conco3mda8: 16,
                concno2: 22,
                concpm10: 16,
                concpm25: 16
            }
        },
        nrms: {
            forecast: {
                conco3: 50,
                conco3mda8: 50,
                concno2: 90,
                concpm10: 80,
                concpm25: 90
            },
            analysis: {
                conco3: 40,
                conco3mda8: 40,
                concno2: 70,
                concpm10: 70,
                concpm25: 60
            }
        }

    } as any
    const isForecast = div.split('_')[0].includes('-an') ? false : true
    const whichTarget = isForecast ? 'forecast' : 'analysis'
    const parameterDir = div.split('_')[2]

    const divElement = document.getElementById(div)
    if (!(divElement instanceof HTMLElement)) return;

    const stats = ['nrms', 'rms', 'mnmb', 'R']
    for (let stat of stats) {
        const thisStat = aeroval.statistics[stat]
        const subDiv = document.createElement("div");
        subDiv.id = `${div}-${stat}`
        divElement.append(subDiv)

        // append subDiv to dov
        const seriesData = []
        const xAxisCategories = []
        const yAxisCategories = [aeroval.statistics[stat].name]
        let i = 0
        for (let year in stripesData) {
            for (let season in stripesData[year]) {
                if (!(stripesData[year] as any)[season]) continue
                let value: number | null = null
                if (stat === 'nrms' && (stripesData[year] as any)[season]['rms'] && (stripesData[year] as any)[season]['refdata_mean']) {
                    value = ((stripesData[year] as any)[season]['rms'] as number) / ((stripesData[year] as any)[season]['refdata_mean'] as number);
                } else {
                    value = (stripesData[year] as any)[season][stat]
                }
                if (!value) continue

                // relative scores
                value = thisStat.unit == '%' ? value * 100 : value;

                const target = targets[stat]?.[whichTarget]?.[parameterDir]
                const isTargetReached = (stat == 'rms' || stat == 'nrms') && value <= target ? true : false
                var className = 'no-target'
                var borderColor = 'gray'
                var dataLabelsColor = 'contrast'
                if (target) {
                    className = isTargetReached ? 'target-reached' : 'target-not-reached'
                    borderColor = isTargetReached ? 'green' : 'red'
                    dataLabelsColor = isTargetReached ? 'darkgreen' : 'darkred'
                }
                var borderWidth = className == 'no-target' ? 0 : 1

                if (aeroval.time == year && aeroval.season == season) borderWidth += 4
                xAxisCategories.push(`${year}-${season}`)
                seriesData.push({
                    x: i,
                    y: 0,
                    value: value,
                    dataLabels: {
                        className: className,
                        style: {
                            color: dataLabelsColor,
                            fill: 'white'
                        }
                    },
                    borderColor: borderColor,
                    borderWidth: borderWidth
                })
                i++
            }
        }

        const series = [{
            data: seriesData,
            dataLabels: {
                enabled: true,
                format: `{point.value:.2f}`,
            }
        }] as any

        let colorAxis = {
            min: 0,
            max: 99,
            minColor: '#FFFFFF',
            maxColor: '#FFFFFF',
            visible: false,
        } as any;

        if (thisStat.scale != null && thisStat.unit != 'var') {
            const stops = [];
            const nStops = 4;
            const min = thisStat.scale[0];
            const max = thisStat.scale[thisStat.scale.length - 1];

            for (let i: number = 0; i < nStops + 1; i++) {
                let value = min + (i * (max - min)) / nStops;
                stops.push([i / nStops, utils.colStat(value, thisStat.scale, stat)]);
            }

            //colorAxis
            colorAxis = {
                stops,
                min,
                max,
                startOnTick: true,
                endOnTick: true,
                reversed: false,
            } as any;
        }

        const xAxisEnabled = stat == stats[stats.length - 1] ? true : false
        const chartHeight = stat == stats[stats.length - 1] ? _chartOptions.height + 70 : _chartOptions.height

        // prepare matrice with nl and nc
        Highcharts.chart({
            chart: {
                renderTo: subDiv,
                type: 'heatmap',
                plotBorderWidth: 1,
                height: chartHeight,
                marginLeft: 80,
                marginRight: 50
            },
            title: {
                text: ``
            },
            xAxis: {
                categories: xAxisCategories,
                visible: xAxisEnabled,
                labels: {
                    rotation: -45
                }
            },
            yAxis: {
                categories: yAxisCategories,
                title: {
                    text: ''
                }
            },
            colorAxis: colorAxis,
            legend: {
                align: 'right',
                layout: 'vertical',
                margin: 0,
                verticalAlign: 'middle',
                enabled: false
            },
            tooltip: {
                valueDecimals: 2
            },
            series: series
        } as any)
    }

}